import { Component, Event, EventEmitter, getAssetPath, h, Host } from '@stencil/core';

import wcShared from '@web-components/shared';

import { SupportPremiumLevelId } from '../../utils/enum';
import { InitStore } from '../../utils/Stores/init-store';
import { SectionStore } from '../../utils/Stores/section-store';
import { Store } from '../../utils/Stores/store';

@Component({
  tag: 'light-header-component',
  styleUrl: 'light-header.scss',
  shadow: true,
})
export class LightHeader {
  @Event() closeEvent: EventEmitter;

  private project = window?.['CURRENT_PROJECT'];
  private supportLevel = Store?.get('supportPremium').supportLevel;

  private goToSupportDashboard() {
    const partnerContactUrl =
      wcShared?.store?.productsRouting?.manager + '/v3/ng/support-premium/dashboard';
    window.open(partnerContactUrl, '_blank', 'noopener,noreferrer');
  }

  private close() {
    this.closeEvent.emit();
  }

  render() {
    return (
      <Host
        class={{
          hide: Store?.get('is_full'),
          'blue-background': SectionStore?.get('section')?.tickets,
        }}
      >
        <div
          class={{
            header: true,
            'background-pro': this.supportLevel === SupportPremiumLevelId.pro,
            'background-business': this.supportLevel === SupportPremiumLevelId.business,
            'background-transparent': SectionStore?.get('section')?.tickets,
          }}
        >
          <div
            class="premium-icon"
            onClick={() => this.goToSupportDashboard()}
          >
            <img
              src={getAssetPath(`./../assets/icons/support-premium/${this.supportLevel}.svg`)}
              alt="icon-support"
            />
          </div>
          <div class="header__user">
            {Boolean(InitStore?.get('init')?.user?.id) ? (
              <module-avatar-component
                name={
                  InitStore?.get('init')?.user?.first_name +
                  ' ' +
                  InitStore?.get('init')?.user?.last_name
                }
                size={45}
                accountId={InitStore?.get('init')?.user?.id}
                logo={InitStore?.get('init')?.user?.avatar_url}
              ></module-avatar-component>
            ) : (
              <a
                href={
                  wcShared?.store?.productsRouting?.welcome + '/auth/login?project=' + this.project
                }
              >
                <img
                  src={Store?.get('userAvatar')?.url}
                  alt={Store?.get('userAvatar')?.name}
                />
                <span>{wcShared?.translate('Se connecter')}</span>
              </a>
            )}
          </div>
          <div
            // eslint-disable-next-line @typescript-eslint/naming-convention
            class={{ header__close: true, hide: window['CHATBOT_FULL'] }}
            onClick={() => this.close()}
          >
            <img
              src={getAssetPath('./../assets/icons/white-cross.svg')}
              alt={wcShared.translate('Fermer')}
            />
          </div>
          <div class="header--separator-cache"></div>
          <div
            class={{
              'header--separator': true,
              'background-pro': this.supportLevel === SupportPremiumLevelId.pro,
              'background-business': this.supportLevel === SupportPremiumLevelId.business,
              'background-transparent': SectionStore?.get('section')?.tickets,
            }}
          ></div>
        </div>
      </Host>
    );
  }
}
